import * as Icons from "lucide-react";

export function ReviewList({ items, tone, emptyMsg, testid }) {
  if ((items || []).length === 0) {
    return <div className="text-sm text-slate-400 italic" data-testid={`${testid}-empty`}>{emptyMsg}</div>;
  }
  return (
    <ul className="space-y-2" data-testid={testid}>
      {items.map((t, i) => (
        <li key={i} className={`text-sm flex gap-2 ${tone === "rose" ? "text-rose-600" : "text-slate-600"}`} data-testid={`${testid}-${i}`}>
          {tone === "rose" ? <Icons.AlertCircle className="h-4 w-4 shrink-0 mt-0.5" /> : tone === "doc" ? <Icons.Square className="h-4 w-4 text-slate-300 shrink-0 mt-0.5" /> : <Icons.Dot className="h-4 w-4 text-blue-400 shrink-0 mt-0.5 -ml-1" />}
          {t}
        </li>
      ))}
    </ul>
  );
}
